/**
 * AddSubCategoryCtrl controller
 * Add/edit subcategories
 */

/**
 * AddSubCategoryCtrl controller
 *
 * @class AddSubCategoryCtrl
 * @memberof mwApp/sets
 * @see mwApp/sets
 *
 * @ngdoc controller
 * @name mwApp/sets.controller:AddSubCategoryCtrl
 */
/* @ngInject */
export default function AddSubCategoryCtrl ($uibModalInstance, sc, subCategoryNames) {
  var vm = this
  vm.sc = sc
  vm.isNew = sc._isNew()

  vm.subCategoryNames = vm.isNew
    ? subCategoryNames
    : subCategoryNames.filter(n => n !== sc.name)

  vm.submit = function () {
    vm.setDisable()
    sc._save(
      sc => {
        sc.categorySet = null
        sc.parentCategory = null
        sc.subCategories = null
        sc.sortOrder = null
      }
    ).then(
      () => $uibModalInstance.close(sc)
    ).finally(vm.unsetDisable)
  }

  vm.cancel = function () {
    $uibModalInstance.dismiss('cancel')
  }
}
